import './Home.scss';
import { Link } from 'react-router-dom';
// Components
import Header from "../components/Header/Header";
import Carousel from "../components/Carousel/Carousel";
import Footer from "../components/Footer/Footer";
import Image from "../components/Image/Image";
import Subscribe from "../components/Subscribe/Subscribe";
import Wppbtn from '../components/Wppbtn/Wppbtn';
import Disclaimer from '../components/Disclaimer/Disclaimer';
// Metadata Component 
import MetaTags from '../components/MetaTags/MetaTags';
// Images
import nutricionistaJPG from '../assets/images/sobre-mi-nutri.jpg';
import nutricionistaMobileJPG from '../assets/images/sobre-mi-mobile.jpg';
import nutricionistaWebp from '../assets/images/sobre-mi-nutri.webp';
import nutricionistaMobileWebp from '../assets/images/sobre-mi-mobile.webp';
// Data
import mealPlansData from '../data/meal-plans.json';
import testimonyData from '../data/testimony.json';


function Home() {
  return (
    <div className="home">
      <MetaTags
                title='Licenciada en Nutrición Belén Olivera'
                description='Comienza tu transformación con la Licenciada en Nutrición Belén Olivera. Atendiendo de forma presencial en Rivera, Uruguay o de forma online para todo el mundo. Te ayudo a mejorar tus hábitos alimenticios, ya sea que busques asesoría para patologías, deporte o salud general. ¡Hagamos de tu bienestar una prioridad y comencemos esta transformación juntos!'
                image='images/logotipo-white-desktop.png'
                name='Lautaro Tamborindeguy'
            />
      <Header />
      <main className="home-welcome">
        <div className="container">
          <div className='content'>
            <h2>¿Estas cansada de probar con dietas que no podes sostener?</h2>
            <p>Mi enfoque <b>te acompaña</b> a bajar de peso <i>sin&nbsp;restricciones, sin culpa</i> y con hábitos que realmente podés mantener en el tiempo.</p>
          </div>
        </div>
      </main>
      <section className="about-section">
        <div className="container">
          <div className="about">
            <h2>Sobre Mí</h2>
            <p>Soy Belén Olivera, licenciada en nutrición. Acompaño a mujeres que ya se cansaron de hacer dieta y quieren dejar atrás el ciclo de frustración, culpa y rebote. Mi enfoque es personalizado, flexible y centrado en hábitos reales que se adaptan a tu vida. No te doy una dieta para seguir al pie de la letra. Te ayudo a entender tu cuerpo, organizar tu alimentación y disfrutar el proceso.</p>
            <Link to='/sobre-mi' className='button'>Saber más</Link>
          </div>
          <div className="image">
            <Image webpDesktopSrc={nutricionistaWebp} webpMobileSrc={nutricionistaMobileWebp} pngDesktopSrc={nutricionistaJPG} pngMobileSrc={nutricionistaMobileJPG} width={1000} height={667} loading={"lazy"}  alt="Nutricionista" dataAnimation="fade-left"/>
          </div>
        </div>
      </section>
      <section className="meal-plans">
        <h2 className="title">Planes de acompañamiento</h2>
        <Carousel cards={mealPlansData.plans}></Carousel>
      </section>
      <section className="work-together">
        <div className="container">
          <div className="content">
            <h2>Este acompañamiento es para vos si:</h2>
            <h3 data-aos="fade-right" data-aos-duration="1000">Probaste miles de dietas y siempre terminas abandonando</h3>
            <p data-aos="fade-right" data-aos-duration="1000">Te sentis frustrada, culpable y cada vez con menos ganas de volver a empezar.</p>
            <h3 data-aos="fade-right" data-aos-duration="1000">Queres bajar de peso pero sin dejar de disfrutar de la comida que te gusta</h3>
            <p data-aos="fade-right" data-aos-duration="1000">No queres vivir a base de ensaladas ni tener miedo de salir a comer algo rico</p>
            <h3 data-aos="fade-right" data-aos-duration="1000">Tenes poco tiempo y necesitas una alimentacion que se adapte a tu rutina</h3>
            <p data-aos="fade-right" data-aos-duration="1000">El plan de alimentacion perfecto para vos es el que esta adaptado a tu rutina, gustos y hábitos</p>
          </div>
        </div>
        <div className="overlay"></div>
      </section>
      <section className="testimony">
        <h2 className="title">Historias de transformación:</h2>
        <Carousel cards={testimonyData.testimony}></Carousel>
      </section>
      <section>
        <Subscribe />
      </section>
      <Wppbtn />
      <Footer />
      <Disclaimer />
    </div>
  );
}

export default Home;